// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__30Fm1","alert":"SettungsInbox_alert__2ggwF"};